/**
 * Skąd bierze się kwota pozycji (`PriceSource`).
 *
 * `CATALOG` — z aktualnego cennika (kwota jest „żywa”), `MANUAL` — nadpisana
 * ręcznie przez operatora; wtedy `priceOverride` jest obowiązkowe, a wiersz
 * dostaje w widoku znacznik ✎ (`BillRowVm.overridden`).
 */
export enum PriceSource {
  CATALOG = 'CATALOG',
  MANUAL = 'MANUAL',
}
